import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { DefaultPageComponent } from "../../shared/page/default-page.component";
import { NavController } from "@ionic/angular";
import { BackNativeService } from "../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../shared/service/comunicator-native/return-native/return-native";
import { ReturnHomeService } from "../../shared/service/comunicator-native/return-home/return-home";
import { AnalyticsGA4PageService } from "../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { platform } from "@ids/tools";

@Component({
  selector: "app-minor",
  templateUrl: "./minor.component.html",
  styleUrls: ["./minor.component.scss"],
})
export class MinorComponent extends DefaultPageComponent implements OnInit {
  headerId = "minor";
  titlePage = "Menor de idade";
  ariaLabelPage = true;
  labelBtnBack = "Fechar";
  showConditionalShimmer = true;
  alertVoiceOver = false;

  private analyticsGA4PagesModel: AnalyticsGA4PagesModel;

  constructor(
    private title: Title,
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    private returnHomeService: ReturnHomeService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPageGA4();
  }

  ngOnInit() {
    this.setTitle();
    this.showConditionalShimmer = false;
    this.focusPage(`#${this.headerId}`, 60);
  }

  backPage() {
    this.returnHomeService.returnCommunicator();
  }

  ionViewWillEnter() {
    this.focusPage(`#${this.headerId}`, 60);
    this.sendTrackGA4LoadPage(this.analyticsGA4PagesModel.customPathMenorDeIdade);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  getPageId(): string {
    return this.headerId;
  }

  handleClick(e) {
    this.sendTrackGA4Entendi(this.analyticsGA4PagesModel.customPathMenorDeIdade);
    this.backJourney();
  }

  getAnalyticsPageGA4() {
    this.analyticsGA4PagesModel =
      this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  sendTrackGA4LoadPage(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameScreenView,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4Entendi(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameClick,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
      detail: "entendi"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  clickTelCap(){
    this.sendTrackGA4TelCap(this.analyticsGA4PagesModel.customPathMenorDeIdade);
  }

  sendTrackGA4TelCap(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameClick,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
      detail: "tel-capitais-regioes"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  clickTelLoc(){
    this.sendTrackGA4TelLoc(this.analyticsGA4PagesModel.customPathMenorDeIdade);
  }

  sendTrackGA4TelLoc(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameClick,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
      detail: "tel-demais-localidades"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  clickDefTelCap(){
    this.sendTrackGA4TelDefCap(this.analyticsGA4PagesModel.customPathMenorDeIdade);
  }

  sendTrackGA4TelDefCap(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameClick,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
      detail: "tel-deficiencia-capitais-regioes"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  clickDefTelLoc(){
    this.sendTrackGA4TelDefLoc(this.analyticsGA4PagesModel.customPathMenorDeIdade);
  }

  sendTrackGA4TelDefLoc(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameClick,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
      detail: "tel-deficiencia-demais-localidades"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }


  focusPage(selector: string, time: number) {
    if (platform.os === "IOS") {
      document.body.setAttribute("aria-hidden", "true");

      setTimeout(() => {
        document.body.removeAttribute("aria-hidden");
        this.focusElement(selector, time);
      }, 300);
    } else {
      this.focusElement(selector, time);
    }
  }

  focusElement(selector: string, time: number) {
    setTimeout(() => {
      const element = document.querySelector(selector) as HTMLElement;
      element?.focus();
    }, time);
  }
}
